import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'
import { draftStatus } from './helper'

const EnrolmentMessage = ({ record }) =>
  !parentApproved(record.parent_approval_status) || draftStatus(record.status) ?
    <Message parent_approval_status={record.parent_approval_status} /> :
    null

const parentApproved = parent_approval_status =>
  // we only return true if parent_approval_status is not present
  // in case the client code is deployed ahead of the api changes.
  parent_approval_status ? !parent_approval_status.failed : true

const Message = ({ parent_approval_status }) => (
  <li>
    <div className="enrolmentMessage--wrapper">
      {!parent_approval_status || !parent_approval_status.reason ? (
        'Xplor will submit this draft once the parent has approved their CWA'
      ) : (
        <FormDisplayErrors errors={parent_approval_status.reason} />
      )}
    </div>
  </li>
)

export default EnrolmentMessage



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/view/enrolment-message.js